<div class="video-player">
  <ut-toolbar
    [title]="video()?.title ?? ('videos.player' | translate)"
    (back)="back()"
  ></ut-toolbar>

  <ut-card padding="none" class="video-player__stage">
    @if (loading()) {
      <ut-skeleton variant="rect" width="100%" height="100%"></ut-skeleton>
    } @else if (url()) {
      <video
        class="video-player__video"
        controls
        autoplay
        playsinline
        [src]="url()!.url"
      ></video>
    } @else if (error()) {
      <ut-empty-state
        icon="alert-circle"
        [title]="'videos.player error title' | translate"
        [description]="'videos.player error description' | translate"
      ></ut-empty-state>
    }
  </ut-card>

  @if (video(); as v) {
    <div class="video-player__meta">
      @if (v.creationDate) {
        <span
          [attr.translate]="null"
        >{{ 'videos.uploaded on'
            | translate: { date: v.creationDate | zonedDate: 'shortDate' } }}</span>
      }
      @if (v.tags && v.tags.length > 0) {
        <span class="video-player__meta-sep">·</span>
        <span class="video-player__tags">{{ v.tags.join(', ') }}</span>
      }
    </div>
  }
</div>
